const DEFERRED_ACTION_KEY = 'wix-chatbot-client-deffered-action';

export const getDeferredAction = () =>
  localStorage.getItem(DEFERRED_ACTION_KEY) === 'true';

export const setDeferredAction = () =>
  localStorage.setItem(DEFERRED_ACTION_KEY, 'true');

export const cleanDeferredAction = () =>
  localStorage.removeItem(DEFERRED_ACTION_KEY);
